<template>
  <div class="page-container content-430 statistics-box">
    <!-- 头部工具栏 -->
    <div class="header-wrapper-430">
      <Card class="sticky">
        <Row>
          <Col class="flex flex-start" span="8">
            <Button type="primary" shape="circle" icon="md-refresh" :loading="loadingFun" @click="getNewStatisc"></Button>
            <div style="margin-left:20px;">截止：{{ timeFont }}</div>
          </Col>
          <Col class="flex flex-end" span="16">
            <div class="basic-info flex">
              <div v-for="item of basicDataShow" :key="item.label" class="info-item">
                {{ item.label }}：{{ item.value }}
              </div>
            </div>
            <div class="select">
              <CascaderYearTerms
                ref="cascaderYearTerms"
                :placeholder="`请选择学期`"
                @on-change="onCascaderChange"
                @getSelectTermName="getSelectTermName"
              ></CascaderYearTerms>
            </div>
            <div class="tool-btn">
              <Icon class="full-screen" type="ios-expand" size="20" title="全屏" @click="handleFullScreen"></Icon>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
    <Card :style="{height:tableHeight+'px'}">
      <div class="table-top">
        <div v-if="+portOrg===1" class="search-line">
          <RemoteSelect
            v-model="schoolId"
            placeholder="请选择学校"
            :remote-method="getSchoolList"
            :loading="loadingSchool"
            class="search-select"
            @clear="getSchoolList('')"
            @visible-change="loadAllList"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.orgId"
              :label="item.schoolName"
              :value="item.orgId"
            >
            </el-option>
          </RemoteSelect>
          <div class="btn-box">
            <Button type="primary" @click="handleSearch">查询</Button>
            <Button class="search-430" @click="handleFormData">重置</Button>
          </div>
          <Button
            class="back"
            type="primary"
            @click="exportMoreHandel"
          >导出</Button>
        </div>
        <div v-if="+portOrg===2" class="search-line">
          <ChooseApply
            ref="chooseApplyRef"
            placeholder="请选择课程提供方"
            org-type=""
            :year-term-code="yearTermCode"
            @on-change="handleOnApplyChange"
          ></ChooseApply>
          <div class="btn-box">
            <Button type="primary" @click="handleSearch">查询</Button>
            <Button class="search-430" @click="handleFormData">重置</Button>
          </div>
          <Button
            class="back"
            type="primary"
            @click="exportMoreHandel"
          >导出</Button>
        </div>
        <div class="table-head">{{ yearnameTermname }}报名数据统计</div>
      </div>
      <Table :loading="tableLoading" show-summary :summary-method="handleSummary" :max-height="tableTrueHeight" :columns="statisticsColumnsShow" :data="statisticsData" border>
        <template slot="orderNo" slot-scope="{ row ,index}">
          {{ index+1 }}
        </template>
        <template slot="artClasses" slot-scope="{ row ,index}">
          {{ row.artClasses | formatNumber }}
        </template>
        <template slot="scienceAndTechnologyCourse" slot-scope="{ row ,index}">
          {{ row.scienceAndTechnologyCourse | formatNumber }}
        </template>
        <template slot="sportsCourse" slot-scope="{ row ,index}">
          {{ row.sportsCourse | formatNumber }}
        </template>
        <template slot="artCourse" slot-scope="{ row ,index}">
          {{ row.artCourse | formatNumber }}
        </template>
        <template slot="comprehensivePracticeCurriculum" slot-scope="{ row ,index}">
          {{ row.comprehensivePracticeCurriculum | formatNumber }}
        </template>
        <template slot="coursePeopleTotal" slot-scope="{ row ,index}">
          {{ row.coursePeopleTotal | formatNumber }}
        </template>
        <template slot="coursePeopleNumber" slot-scope="{ row ,index}">
          {{ row.coursePeopleNumber | formatNumber }}
        </template>
        <template slot="studentsEnrollment" slot-scope="{ row ,index}">
          {{ row.studentsEnrollment | formatNumber }}
        </template>
        <template slot="noonCare" slot-scope="{ row ,index}">
          {{ row.noonCare | formatNumber }}
        </template>
        <template slot="lateCare" slot-scope="{ row ,index}">
          {{ row.lateCare | formatNumber }}
        </template>
        <template slot="fullCare" slot-scope="{ row ,index}">
          {{ row.fullCare | formatNumber }}
        </template>
        <template slot="carePeopleTotal" slot-scope="{ row ,index}">
          {{ row.carePeopleTotal | formatNumber }}
        </template>
        <template slot="carePeopleNumber" slot-scope="{ row ,index}">
          {{ row.carePeopleNumber | formatNumber }}
        </template>
        <template slot="peopleTotal" slot-scope="{ row ,index}">
          {{ row.peopleTotal | formatNumber }}
        </template>
        <template slot="peopleNumber" slot-scope="{ row ,index}">
          {{ row.peopleNumber | formatNumber }}
        </template>

        <template slot="action" slot-scope="{ row }">
          <span
            class="ordinary-color-430"
            @click="handleToDetail(row)"
          >查看详情</span>
        </template>
      </Table>
    </Card>

    <div>
      <Modal
        v-model="showExportModal"
        title="正在导出"
        :mask-closable="false"
        @on-cancel="handleCancelExport"
      >
        <Progress :percent="percent" :stroke-width="5"></Progress>
        正在导出表格，请给我一些时间，请不要关闭当前页面！
        <div slot="footer">
          <Button @click="handleCancelExport">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapState } from 'vuex';
import RemoteSelect from '@c/RemoteSelect';
import ChooseApply from '@c/searchBlock/ChooseApply';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { priceFormat, formatTime } from '@/utils/utils';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import orderCenterApi from '@/request/orderCenter/index.js';
import educationAdmin from '@/request/educationAdmin/index.js';
import resourcesManagementApi from '@/request/courseCenter/resources';
let IntervalId;
export default {
  components: {
    RemoteSelect,
    CascaderYearTerms,
    ChooseApply
  },
  filters: {
    formatNumber(num) {
      return priceFormat(num);
    }
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      showExportModal: false,
      source: null,
      percent: 0,
      loadingFun: false,
      timeFont: '',
      /* 数据概览 */
      basicData: [
        {
          label: '学校数',
          tag: 'schoolNumber',
          value: '-'
        },
        {
          label: '机构数',
          tag: 'orgNumber',
          value: '-'
        },
        {
          label: '学生数',
          tag: 'studentsNumber',
          value: '-'
        }
      ],
      // 学年
      yearCode: '',
      // 学期
      termCode: '',
      schoolId: -1,
      loadingSchool: false,
      schoolList: [],
      schoolPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      tableLoading: false,
      statisticsColumns: [
        {
          title: '序号',
          slot: 'orderNo',
          key: 'orderNo',
          align: 'center',
          minWidth: 100,
          fixed: 'left'
        },

        {
          title: '素质课程',
          align: 'center',
          children: [
            {
              title: '艺术',
              key: 'artClasses',
              slot: 'artClasses',
              align: 'center',
              minWidth: 100
            },
            {
              title: '科技',
              key: 'scienceAndTechnologyCourse',
              slot: 'scienceAndTechnologyCourse',
              align: 'center',
              minWidth: 100
            },
            {
              title: '体育',
              key: 'sportsCourse',
              slot: 'sportsCourse',
              align: 'center',
              minWidth: 100
            },
            {
              title: '美术',
              key: 'artCourse',
              slot: 'artCourse',
              align: 'center',
              minWidth: 100
            },
            {
              title: '综合实践',
              key: 'comprehensivePracticeCurriculum',
              slot: 'comprehensivePracticeCurriculum',
              align: 'center',
              minWidth: 130
            }, {
              title: '合计（人次）',
              key: 'coursePeopleTotal',
              slot: 'coursePeopleTotal',
              align: 'center',
              minWidth: 150
            }, {
              title: '报名人数',
              key: 'coursePeopleNumber',
              slot: 'coursePeopleNumber',
              align: 'center',
              minWidth: 150
            }, {
              title: '在校学生人数',
              key: 'studentsEnrollment',
              slot: 'studentsEnrollment',
              align: 'center',
              minWidth: 150
            }, {
              title: '报名率',
              key: 'courseEnrollment',
              align: 'center',
              minWidth: 150
            }
          ]
        },
        {
          title: '托管课程',
          align: 'center',
          children: [
            {
              title: '午托',
              key: 'noonCare',
              slot: 'noonCare',
              align: 'center',
              minWidth: 100
            },
            {
              title: '基本托管',
              key: 'lateCare',
              slot: 'lateCare',
              align: 'center',
              minWidth: 130
            },
            {
              title: '晚修',
              key: 'fullCare',
              slot: 'fullCare',
              align: 'center',
              minWidth: 100
            }, {
              title: '合计（人次）',
              key: 'carePeopleTotal',
              slot: 'carePeopleTotal',
              align: 'center',
              minWidth: 150
            }, {
              title: '报名人数',
              key: 'carePeopleNumber',
              slot: 'carePeopleNumber',
              align: 'center',
              minWidth: 150
            }, {
              title: '在校学生人数',
              key: 'studentsEnrollment',
              slot: 'studentsEnrollment',
              align: 'center',
              minWidth: 150
            }, {
              title: '报名率',
              key: 'careEnrollment',
              align: 'center',
              minWidth: 150
            }
          ]
        },
        {
          title: '合计报名（人次）',
          key: 'peopleTotal',
          slot: 'peopleTotal',
          align: 'center',
          minWidth: 150
        }, {
          title: '合计报名人数',
          key: 'peopleNumber',
          slot: 'peopleNumber',
          align: 'center',
          minWidth: 150
        }, {
          title: '在校学生人数',
          key: 'studentsEnrollment',
          slot: 'studentsEnrollment',
          align: 'center',
          minWidth: 150
        }, {
          title: '报名率',
          key: 'enrollment',
          align: 'center',
          minWidth: 150
        }, {
          title: '操作',
          slot: 'action',
          key: 'action',
          align: 'center',
          minWidth: 100,
          fixed: 'right'
        }
      ],
      statisticsData: [],
      tableTopHeight: 0,
      yearnameTermname: '',
      yearTermCode: [],
      orgId: -1, // 学校端选择的课程提供方
      educationBureauId: '' // 教育局id，适用于学校端
    };
  },
  computed: {
    ...mapState(['userInfo', 'portOrg']),
    tableTrueHeight() {
      return this.tableHeight - this.tableTopHeight;
    },
    basicDataShow() {
      if (+this.portOrg === 1) {
        return this.basicData;
      } else if (+this.portOrg === 2) {
        return this.basicData.filter(item => {
          return item.tag !== 'schoolNumber';
        });
      } else {
        return [];
      }
    },
    statisticsColumnsShow() {
      if (+this.portOrg === 1) {
        return this.statisticsColumns.toSpliced(1, 0, {
          title: '学校',
          key: 'schoolName',
          align: 'center',
          minWidth: 200,
          fixed: 'left'
        });
      } else if (+this.portOrg === 2) {
        return this.statisticsColumns.toSpliced(1, 0, {
          title: '课程提供方',
          key: 'orgName',
          align: 'center',
          minWidth: 200,
          fixed: 'left'
        });
      } else {
        return [];
      }
    }
  },
  mounted() {
    this.tableTopHeight = document.querySelector('.table-top')
      ? document.querySelector('.table-top').clientHeight
      : 0;
  },
  methods: {
    async init() {
      if (+this.portOrg === 1) {
        this.getSchoolList();
      } else if (+this.portOrg === 2) {
        this.educationBureauId = await this.getRelEduFun(this.userInfo.orgId);
      }
      this.getNewStatisc();
    },
    // 学校端获取所在教育局id
    async getRelEduFun(orgId) {
      return new Promise(async(resolve, reject) => {
        try {
          const res = await resourcesManagementApi.getRelEdu({
            orgId: orgId
          });
          if (res.status === 200 && res.message && res.message.length > 0) {
            resolve(res.message[0].orgId);
          } else {
            reject(false);
          }
        } catch (err) {
          reject(false);
        }
      });
    },
    getSelectTermName(name) {
      this.yearnameTermname = name;
    },
    onCascaderChange(v) {
      console.log(v, '年度资源学期');
      this.yearTermCode = v;
      this.yearCode = v[0];
      this.termCode = v[1];
      const sysYt = this.$refs.cascaderYearTerms.getObjResult();
      console.log(sysYt, '拿到的----');
      this.init();
    },
    // 提供方组件值改变
    handleOnApplyChange(val) {
      this.orgId = val.orgId === '' ? null : val.orgId;
      // if (this.leaveListForTeacherSearch) {
      //   this.formValidate.orgId = val.orgId === '' ? null : val.orgId;
      // } else {
      //   this.formValidate.orgId = val.orgId;
      // }
    },
    /** ***** 有关学校列表的操作 start  ********/
    loadAllList(val) {
      if (!val) {
        this.getSchoolList('');
      }
    },
    // 获取学校列表
    getSchoolList(query) {
      query ? (this.loadingSchool = true) : '';
      const queryTrue = {
        orgName: query,
        yearCode: this.yearCode,
        termCode: this.termCode,
        orgType: 1
      };
      this.getSchoolListAdmin(queryTrue);
    },
    // 请求学校列表(运营端,教育局端,机构端)
    async getSchoolListAdmin(query) {
      const params = Object.assign(this.schoolPageInfo, query);
      const res = await orderCenterApi.getWxOrgList(params);
      if (res.status === 200) {
        this.schoolList = res.message.list.map(item => {
          item.schoolId = item.orgId;
          item.schoolName = item.name || item.orgName;
          return item;
        });
        this.schoolList.unshift({
          schoolId: -1,
          schoolName: '全部学校',
          orgId: -1,
          name: '全部学校'
        });
        this.schoolPageInfo.total = Number(res.message.total);
        this.loadingSchool = false;
      }
    },
    /** ***** 有关学校列表的操作 end  ********/
    async getNewStatisc() {
      this.loadingFun = true;
      const time = new Date();
      this.timeFont = formatTime(time, 'yyyy-MM-dd hh:mm:ss');

      const promise1 = this.getTotalData();
      const promise2 = this.getStatisticInfoData();
      Promise.allSettled([promise1, promise2]).then(res => {
        this.loadingFun = false;
      });
    },
    // 获取学校和机构数
    async getTotalData() {
      return new Promise(async(resolve, reject) => {
        this.basicData = this.basicData.map(item => {
          return {
            ...item,
            value: '-'
          };
        });
        try {
          const params = {
            educationBureauId: +this.portOrg === 1 ? this.userInfo.orgId : this.educationBureauId,
            termCode: this.termCode,
            yearCode: this.yearCode
          };
          const res = await educationAdmin.termServiceSchoolNumberApi(params);
          if (res.status === 200) {
            this.basicData = this.basicData.map(item => {
              return {
                ...item,
                value: res.message[item.tag] ? res.message[item.tag] : 0
              };
            });
            resolve(true);
          } else {
            reject(false);
          }
        } catch (err) {
          reject(err);
        }
      });
    },
    // 获取教育局端的报名统计数据
    async getStatisticInfoData() {
      const params = {
        yearCode: this.yearCode,
        termCode: this.termCode,
        educationBureauId: +this.portOrg === 1 ? this.userInfo.orgId : this.educationBureauId
      };
      this.schoolId === -1 ? '' : params.schoolId = this.schoolId;
      this.orgId === -1 ? '' : params.orgId = this.orgId;
      this.tableLoading = true;
      this.statisticsData = [];
      return new Promise(async(resolve, reject) => {
        try {
          const res = await educationAdmin.courseRegistrationDataApi(params);
          if (res.status === 200) {
            this.statisticsData = res.message.map(item => {
              item.careEnrollment = item.careEnrollment || '0.00%';
              item.courseEnrollment = item.courseEnrollment || '0.00%';
              item.enrollment = item.enrollment || '0.00%';
              return item;
            });
            resolve(true);
          } else {
            reject(false);
          }
        } catch (err) {
          reject(err);
        } finally {
          this.tableLoading = false;
        }
      });
    },
    // 表格总计
    handleSummary({ columns, data }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        if (index === 1) {
          sums[key] = {
            key,
            value: '合计'
          };
          return;
        }
        if (key === 'orderNo' || key === 'action') {
          sums[key] = {
            key,
            value: ''
          };
          return;
        }
        // 报名率的
        if (key === 'careEnrollment' || key === 'courseEnrollment' || key === 'enrollment') {
          let numerator = 0;
          let Denominator = 0;
          let list1 = [];
          const list2 = data.map(item => Number(item.studentsEnrollment));
          switch (key) {
            case 'careEnrollment':
              list1 = data.map(item => Number(item.carePeopleNumber));
              break;
            case 'courseEnrollment':
              list1 = data.map(item => Number(item.coursePeopleNumber));
              break;
            case 'enrollment':
              list1 = data.map(item => Number(item.peopleNumber));
              break;
            default:
              break;
          }
          numerator = list1.reduce((prev, curr) => {
            return prev + curr;
          }, 0);
          Denominator = list2.reduce((prev, curr) => {
            return prev + curr;
          }, 0);
          sums[key] = {
            key,
            value: ((Denominator === 0 ? 0 : (numerator / Denominator)) * 100).toFixed(2) + '%'
          };
          return;
        }
        if (key === 'studentsEnrollment' && +this.portOrg === 2) {
          sums[key] = {
            key,
            value: ''
          };
          return;
        }

        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[key] = {
            key,
            value: priceFormat(v)
          };
        } else {
          sums[key] = {
            key,
            value: 'N/A'
          };
        }
      });
      return sums;
    },

    handleSearch() {
      this.getNewStatisc();
    },
    // 查看报名数据详情
    handleToDetail(row) {
      const schoolSelectList = {
        order: row.schoolId
      };
      localStorage.setItem(
        'schoolSelectList',
        JSON.stringify(schoolSelectList)
      );
      const query = { yearCode: this.yearCode, termCode: this.termCode };
      if (+this.portOrg === 2) {
        query.orgId = row.orgId;
      }
      const { href } = this.$router.resolve({
        name: 'orderCenter_order_orderTable',
        query: query
      });
      window.open(href);
    },
    handleFormData() {
      this.schoolId = -1;
      this.orgId = -1;
      this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear();
      this.handleSearch();
    },
    percentShow() {
      this.percent = 0;
      IntervalId = setInterval(this.percentShowFun, 500);
    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.percent += 20;
      if (this.percent >= 80) {
        clearInterval(IntervalId);
      }
    },
    // 导出数据
    async exportMoreHandel() {
      this.percentShow();
      this.showExportModal = true;
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      const params = {
        yearCode: this.yearCode,
        termCode: this.termCode,
        educationBureauId: +this.portOrg === 1 ? this.userInfo.orgId : this.educationBureauId
      };
      this.schoolId === -1 ? '' : params.schoolId = this.schoolId;
      this.orgId === -1 ? '' : params.orgId = this.orgId;
      const res = await educationAdmin.courseRegistrationExportApi(params, this.source.token);
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(IntervalId);
            this.percent = 100;
            setTimeout(() => {
              this.showExportModal = false;
              this.showSelectExportModal = false;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(IntervalId);
            this.percent = 60;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            this.$Message.error(resData.error);
          }
        };
      } else {
        this.showExportModal = false;
      }
    },
    // 导出-进度条
    handleCancelExport() {
      this.source.cancel('取消请求');
    },
    handleFullScreen() {
      const isSafari = !!document.webkitCancelFullScreen;
      const flag = document.fullscreenElement || document.webkitIsFullScreen;
      if (flag) {
        isSafari ? document.webkitCancelFullScreen() : document.exitFullscreen();
      } else {
        const dom = document.querySelector('.ivu-layout-content');
        isSafari ? dom.webkitRequestFullscreen() : dom.requestFullscreen();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.statistics-box{
  min-width: 1200px;
  padding: 16px;
  background: #eef0f3;
}
.sticky{
  width: 100%;
  margin-bottom: 16px;
}
.table-card{
  box-sizing: border-box;
  padding: 16px;
}
.flex {
  display: flex;
  align-items: center;
}

.flex-end {
  justify-content: flex-end;
}
.flex-start{
  justify-content: flex-start;
}
.basic-info {
    padding: 8px 20px;
    background-color: rgba(240, 244, 249, 1);

    .info-item {
      font-size: 14px;
      color: #8690a5;
      margin-right: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .select {
    margin: 0 30px;
  }

  .tool-btn {
    .full-screen {
      cursor: pointer;
      transition: all 0.3s ease-in-out;

      &:hover {
        transform: rotate(180deg);
      }
    }
  }
.table-head{
  height: 48px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcdee2;
  border-bottom: none;
  font-weight: bold;
  background: #f8f8f9;
}
.search-line{
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .search-select{
    width: 200px;
  }
  .btn-box{
    margin-left: 40px;
  }
  .back{
    margin-left: auto;
  }
}
</style>
